export function cruiseControlEnabled() {
    return !!window.marque.ui.features.ai.cruise_control.enabled;
}
export function autoRespondEnabled() {
    return window.marque.ui.features.ai.cruise_control.auto_respond &&
        cruiseControlEnabled();
}
